import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormactionService } from '../../api/formaction.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: 'app-crilist',
  templateUrl: './crilist.component.html',
  styleUrls: ['./crilist.component.css']
})
export class CrilistComponent implements OnInit {

  public eriTable: any;
  public eriPendingTable: any;
  public erirRes_RejTable: any;
  public bool_updt_btn: boolean = false;
  public bool_edit_btn: boolean = false;
  public bool_view_btn: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('t1Sort') t1Sort!: MatSort;
  @ViewChild('t1Paginator') t1Paginator!: MatPaginator;

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private formaction: FormactionService) { }

  displayedColumns = ['refno', 'iticode', 'trade', 'username', 'regno', 'Status'];
  SRC_SELECTED_FAMILYMEMBER: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
  dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  selected_family_member = new SelectionModel<Element>(true, []);
  public int_index_edit: any;

  displayedColumns_view = ['refno', 'iticode', 'trade', 'username', 'regno', 'status', 'action'];
  SRC_SELECTED_VIEW: Element_View[] = [];
  DATA_SELECTED_VIEW = Object.assign(this.SRC_SELECTED_VIEW);
  dataSource_view = new MatTableDataSource<Element_View>(this.DATA_SELECTED_VIEW);
  selected_view = new SelectionModel<Element_View>(true, []);
  public int_index_edit_view: any;


  applyFilter(filterValue: any) {
    filterValue = filterValue.target.value.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  applyFilterView(filterValue: any) {
    filterValue = filterValue.target.value.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource_view.filter = filterValue;
  }

  ngOnInit(): void {
    this.api.criList().subscribe((result: any) => {
      this.eriTable = result;
      console.log("EriList: " + JSON.stringify(result))
      this.SRC_SELECTED_FAMILYMEMBER = result;
      this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
      this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
      //this.ngAfterViewInit();
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      for (var i = 0; i < this.eriTable.length; i++) {
        console.log("list" + JSON.stringify(this.eriTable[i]['admin_status']))

        if (result[i]['admin_status'] == 'pending') {
          this.bool_updt_btn = true;
        }
      }
    })

    this.api.eriPendingList().subscribe((result: any) => {
      this.eriPendingTable = result;
    })

    this.api.criRes_RejList().subscribe((result: any) => {
      this.erirRes_RejTable = result;

      this.SRC_SELECTED_VIEW = result;
      this.DATA_SELECTED_VIEW = Object.assign(this.SRC_SELECTED_VIEW);
      this.dataSource_view = new MatTableDataSource<Element_View>(this.DATA_SELECTED_VIEW);

      this.dataSource_view.paginator = this.t1Paginator;
      this.dataSource_view.sort = this.t1Sort;



    })
  }

  editEri(i: any) {
    var args = {
      refno: this.eriTable[i]['refno'],
      iticode: this.eriTable[i]['iticode'],
      trade: this.eriTable[i]['trade'],
      regno: this.eriTable[i]['regno'],
      username: this.eriTable[i]['username'],
    };
    this.formaction.set_criList_single(args);
    this.router.navigateByUrl('/dashboard/criedit')
  }

  editEriPending(i: any) {
    var args = {
      refno: this.eriPendingTable[i]['refno'],
      iticode: this.eriPendingTable[i]['iticode'],
      trade: this.eriPendingTable[i]['trade'],
      regno: this.eriPendingTable[i]['regno'],
      username: this.eriPendingTable[i]['username'],
    };
    this.formaction.set_eriList_single(args);
    this.router.navigateByUrl('/dashboard/eriedit')
  }

  editEriRes_Rej(i: any) {
    var args = {
      refno: this.erirRes_RejTable[i]['refno'],
      iticode: this.erirRes_RejTable[i]['iticode'],
      trade: this.erirRes_RejTable[i]['trade'],
      regno: this.erirRes_RejTable[i]['regno'],
      username: this.erirRes_RejTable[i]['username'],
    };
    this.formaction.set_eriList_single(args);
    this.router.navigateByUrl('/dashboard/eriview')
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;

  }

  report() {
    this.selected_family_member.selected.forEach((item) => {
      // let index: number = this.DATA_SELECTED_FAMILYMEMBER.findIndex((d: any) => d === item);
      // this.int_index_edit = index;
      var msg = JSON.stringify(item);
      //console.log("MSG: " + msg)
      var parsedarray = JSON.parse(msg);

      var args = {
        refno: parsedarray['refno'],
        iticode: parsedarray['iticode'],
        trade: parsedarray['trade'],
        regno: parsedarray['regno'],
        username: parsedarray['username'],
      };
      console.log(args)
      this.formaction.set_criList_single(args);
      this.router.navigateByUrl('/dashboard/criedit')

    });

    this.selected_family_member.clear();
  }

  report_view() {

    this.selected_view.selected.forEach((item) => {
      // let index: number = this.DATA_SELECTED_FAMILYMEMBER.findIndex((d: any) => d === item);
      // this.int_index_edit = index;
      var msg = JSON.stringify(item);
      //console.log("MSG: " + msg)
      var parsedarray = JSON.parse(msg);

      var args = {
        refno: parsedarray['refno'],
        iticode: parsedarray['iticode'],
        trade: parsedarray['trade'],
        regno: parsedarray['regno'],
        username: parsedarray['username'],
      };
      console.log(args)
      this.formaction.set_criList_single(args);
      this.router.navigateByUrl('/dashboard/criviewadmin')

    });

    this.selected_view.clear();
  }

}

export interface Element {
  refno: string;
  iticode: string;
  trade: string;
  regno: string;
  username: string;
  Status: string;
}

export interface Element_View {
  refno: string;
  iticode: string;
  trade: string;
  regno: string;
  username: string;
  status: string;
  action: string;
}



// const ELEMENT_DATA: Element[] = [
//   { refno: '1', username: 'Hydrogen', regno: '1.0079', iticode: 'H', ntef: 'a', issuedetail: 'issuedetail' },

// ];